<template>
  <AttributeTable
    :value="value"
    @input="e => $emit('input', e)"
    :selectable="selectable"
    :title="title"
    :attributes="attributes">

    <!-- notification -->
    <template v-if="n" #pre>
      <tr>
        <th class="has-text-info">Device</th>
        <td><DeviceId :id="n.deviceId"/></td>
      </tr>
      <tr>
        <th class="has-text-info">Message</th>
        <td>{{ n.message }}</td>
      </tr>
      <tr>
        <th class="has-text-info">Raised at</th>
        <td>{{ n['@timestamp'] }}</td>
      </tr>
    </template>
    <!-- eo:notification -->

    <!-- special case: content -->
    <template #value-content="a">

      <!-- conversation snapshot -->
      <ConversationSnapshot v-if="eventType === conversationScreenScraped" :content="a.value" />
      <!-- eo:conversation snapshot -->

      <!-- default viewer -->
      <div class="default-viewer" v-else>{{ a.value }}</div>
      <!-- eo:default viewer -->
      
    </template>
    <!-- eo:special case: content -->

  </AttributeTable>
</template>

<script>
import { eventTypeConversationScreenScraped } from '@/services/consts'

export default {
  emits: ['input'],
  props: {
    n: Object,
    title: String,
    attributes: Array,
    value: Array,
    selectable: Boolean,
  },
  computed: {
    conversationScreenScraped () { return eventTypeConversationScreenScraped },
    eventType () { 
      const matches = this.attributes.filter(k => k.key === 'eventType') 
      if (matches.length === 0) return null
      return matches[0].value
    },
  }
}
</script>